import React from 'react';
import ReactDOM from 'react-dom';
import SignInModal from './SignInModal';

const renderSignInModal = () => {
  const mountNode = document.querySelector('[react-render-target="SignInModal"]');
  if (mountNode) ReactDOM.render(<SignInModal />, mountNode);
  else console.warn('missing render target: SignInModal');
};

export const initSignInModal = () => {
  renderSignInModal();
};
